/**
 * Full-screen lookbook overlay: an editorial image grid that opens in a native
 * <dialog>, with a per-image lightbox layered on top of the grid inside the
 * same dialog. Plain DOM APIs only -- no base-theme component framework.
 */
(function () {
  function init() {
    const root = document.getElementById('lookbook');
    if (!root) return;

    const trigger = document.getElementById('lookbook-trigger');
    const dialog = document.getElementById('lookbook-dialog');
    const closeButton = document.getElementById('lookbook-close');
    const lightbox = document.getElementById('lookbook-lightbox');
    const lightboxImage = document.getElementById('lookbook-lightbox-image');
    const lightboxClose = document.getElementById('lookbook-lightbox-close');
    if (!trigger || !dialog || !closeButton || !lightbox || !lightboxImage || !lightboxClose) return;

    let previousScrollY = 0;
    let lightboxOpen = false;
    let gridScrollY = 0;
    let selectedItem = null;

    function openLookbook() {
      if (dialog.open) return;

      previousScrollY = window.scrollY;

      requestAnimationFrame(() => {
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${previousScrollY}px`;

        dialog.showModal();
        document.addEventListener('keydown', handleKeydown);
      });
    }

    function closeLookbook() {
      if (!dialog.open) return;

      document.removeEventListener('keydown', handleKeydown);
      closeLightbox();

      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo({ top: previousScrollY, behavior: 'instant' });

      dialog.close();
    }

    function openLightbox(event) {
      const item = event.target.closest('[data-full-src]');
      if (!item) return;

      const fullSrc = item.getAttribute('data-full-src');
      if (!fullSrc) return;

      gridScrollY = dialog.scrollTop;
      selectedItem = item;
      dialog.scrollTop = 0;
      lightboxImage.src = fullSrc;
      lightboxImage.alt = item.getAttribute('data-alt') || '';
      lightbox.hidden = false;
      dialog.classList.add('lookbook--item-open');
      lightboxOpen = true;
      lightboxClose.focus({ preventScroll: true });
    }

    function closeLightbox() {
      if (!lightboxOpen) return;

      lightbox.hidden = true;
      dialog.classList.remove('lookbook--item-open');
      lightboxImage.removeAttribute('src');
      lightboxOpen = false;
      dialog.scrollTop = gridScrollY;
      if (selectedItem) selectedItem.focus({ preventScroll: true });
    }

    function handleKeydown(event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();

      if (lightboxOpen) {
        closeLightbox();
      } else {
        closeLookbook();
      }
    }

    trigger.addEventListener('click', openLookbook);
    closeButton.addEventListener('click', closeLookbook);
    lightboxClose.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeLookbook();
    });

    dialog.addEventListener('click', openLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
